import { EmcPanelWrapper, EmcPanelTitle, InfoPopoverWrap, PopoverArrowWrap, PopoverArrow, PopoverContent, PopoverHeader, 
  PopoverItem, InfoWrap, Info, ArrowIcon, QRCodeButton } from './styles';
import { CopyToClipboardWrapper } from './CopyToClipboardWrapper';
import { ButtonTypes } from '@common/components';
import { useState, useEffect } from 'react';
import { Popover } from 'react-tiny-popover';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useGetSvgQrCodeForUrl } from '@common/hooks/useGetSvgQrCodeForUrl';
import { useGetPngQrCodeForUrl } from '@common/hooks/useGetPngQrCodeForUrl';

interface IEmcLinkPanel {
  title: string;
  emcUrl: string;
  showQrCode?: boolean;
}

const getFileName = (contentDisposition?: string) => contentDisposition?.split('filename=')[1].split(';')[0] as string;

const EmcLinkPanel = ({ title, emcUrl, showQrCode }: IEmcLinkPanel) => {
    const [isActive, setIsActive] = useState(false);
    const [qrCodeRequest, setQrCodeRequest] = useState<{ type: 'svg' | 'png'; scale?: string } | null>(null);
    
    const ref = useDetectClickOutside({
      onTriggered: () => isActive && setIsActive(!isActive),
    });

    // Add /QR suffix only for QR code generation
    const qrCodeUrl = `${emcUrl}/QR`;

    const { data: svgQrCodeData } = useGetSvgQrCodeForUrl(qrCodeUrl, qrCodeRequest?.type === 'svg');
    const { data: pngQrCodeData } = useGetPngQrCodeForUrl(qrCodeUrl, qrCodeRequest?.scale || 'small', qrCodeRequest?.type === 'png');

    const downloadFile = (data: any, defaultFileName: string, defaultContentType: string) => {
      if (data) {
        const fileName = getFileName(data.headers['content-disposition'] as string) || defaultFileName;
        const contentType = data.headers['content-type'] || defaultContentType;
        const file = new File([data.data], fileName, { type: contentType });
        const url = window.URL.createObjectURL(file);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        setTimeout(() => {
          a.remove();
          URL.revokeObjectURL(url);
        }, 100);
      }
    };

    useEffect(() => {
      if (qrCodeRequest?.type === 'svg' && svgQrCodeData) {
        downloadFile(svgQrCodeData, 'qr-code.svg', 'image/svg+xml');
        setQrCodeRequest(null);
      }
    }, [svgQrCodeData, qrCodeRequest]);

    useEffect(() => {
      if (qrCodeRequest?.type === 'png' && pngQrCodeData) {
        const fileName = `qr-code-${qrCodeRequest.scale}.png`;
        downloadFile(pngQrCodeData, fileName, 'image/png');
        setQrCodeRequest(null);
      }
    }, [pngQrCodeData, qrCodeRequest]);

    const handleDownloadSvgQrCode = () => setQrCodeRequest({ type: 'svg' });
    const handleDownloadSmallPngQrCode = () => setQrCodeRequest({ type: 'png', scale: 'small' });
    const handleDownloadMediumPngQrCode = () => setQrCodeRequest({ type: 'png', scale: 'medium' });
    const handleDownloadLargePngQrCode = () => setQrCodeRequest({ type: 'png', scale: 'large' });

  return (
    <EmcPanelWrapper>
      <EmcPanelTitle>{title}</EmcPanelTitle>
      <CopyToClipboardWrapper displayText={emcUrl} />
      <>
        {showQrCode ? (
          <Popover
            ref={ref}
            isOpen={isActive}
            positions={['bottom', 'left']}
            content={
              <InfoPopoverWrap>
                  <PopoverArrowWrap>
                    <PopoverArrow />
                  </PopoverArrowWrap>
                  <PopoverContent>
                    <PopoverHeader>Select the size and format of the<br/>QR Code image</PopoverHeader>
                    <PopoverItem>Use PNG for digital, on-screen and small scale printing<br/>and use SVG for high quality printing</PopoverItem>
                    <PopoverItem><QRCodeButton type={ButtonTypes.PRIMARY} onClick={handleDownloadSmallPngQrCode}>PNG - Small</QRCodeButton></PopoverItem>
                    <PopoverItem><QRCodeButton type={ButtonTypes.PRIMARY} onClick={handleDownloadMediumPngQrCode}>PNG - Medium</QRCodeButton></PopoverItem>
                    <PopoverItem><QRCodeButton type={ButtonTypes.PRIMARY} onClick={handleDownloadLargePngQrCode}>PNG - Large</QRCodeButton></PopoverItem>
                    <PopoverItem><QRCodeButton type={ButtonTypes.PRIMARY} onClick={handleDownloadSvgQrCode}>SVG</QRCodeButton></PopoverItem>
                  </PopoverContent>
                </InfoPopoverWrap>
            }
          >
        <InfoWrap onClick={() => setIsActive(!isActive)}>
          <Info>Generate QR Code</Info>
          <ArrowIcon isActive={isActive} />
        </InfoWrap>
      </Popover> ): ""
      }
      </>

    </EmcPanelWrapper>
  );
};

export default EmcLinkPanel;
